// src/components/ui/TextArea.tsx
import React from "react";

type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  error?: string;
};

export default function TextArea({
  label,
  error,
  className,
  ...props
}: Props) {
  return (
    <label className="block">
      {label ? (
        <span className="mb-1 block text-sm font-medium text-slate-700">
          {label}
        </span>
      ) : null}
      <textarea
        {...props}
        className={`w-full rounded-lg border px-3 py-3 text-sm outline-none transition focus:border-slate-400 ${
          error ? "border-red-400 bg-red-50" : "border-slate-300 bg-white"
        } ${className ?? ""}`}
      />
      {error ? <span className="mt-1 block text-xs text-red-600">{error}</span> : null}
    </label>
  );
}
